import { isDevelopmentEnvironment } from "./estada-config";

function getErrorObject(): any {
  try {
    throw Error("");
  } catch (err) {
    return err;
  }
}

enum LoggerMode {
  OFF = "O",
  DEBUG = "D",
  ERROR = "E",
}

export default class Logger {
  static allLoggers = new Array<Logger>();
  static allIncludes: Array<string> | undefined;
  static allLoggerParents = new Map<string, string>();

  static _allLoggerModes: Record<string, LoggerMode> | undefined = undefined;
  static get allLoggerModes(): Record<string, LoggerMode> {
    if (this._allLoggerModes == undefined) {
      const sAllModes = localStorage.getItem("debuglevels");
      if (sAllModes) {
        this._allLoggerModes = JSON.parse(sAllModes);
      } else {
        this._allLoggerModes = {};
      }
    }

    return this._allLoggerModes || {};
  }

  static updateAllLoggersMode() {
    this.allLoggers.forEach((logger) => {
      logger.applyMode();
    });
  }

  set includes(newValue: string) {
    if (newValue.trim() == "") {
      Logger.allIncludes = undefined;
    } else {
      Logger.allIncludes = newValue.split(";");
    }
  }

  get includes(): string {
    if (Logger.allIncludes) {
      return Logger.allIncludes.join(";");
    } else {
      return "";
    }
  }

  className: string;
  logEnabled = true;

  get jsonName(): string {
    let n = this.className;
    n = n.split(".")[0];
    n = n.replace(/[^a-zA-Z0-9]/g, "_");

    return `debuglevel_${n}`;
  }

  _mode: LoggerMode | undefined = undefined;

  set mode(newValue: LoggerMode) {
    this._mode = newValue;
    if (newValue == LoggerMode.OFF) {
      delete Logger.allLoggerModes[this.jsonName];
    } else {
      Logger.allLoggerModes[this.jsonName] = newValue;
    }

    localStorage.setItem("debuglevels", JSON.stringify(Logger.allLoggerModes));

    this.applyMode();
  }

  get mode(): LoggerMode {
    if (this._mode == undefined) {
      this._mode = Logger.allLoggerModes[this.jsonName] || LoggerMode.OFF;
    }
    return this._mode || LoggerMode.OFF;
  }

  applyMode() {
    let m = this.mode;
    if (!isDevelopmentEnvironment()) {
      m = LoggerMode.OFF;
    }

    switch (m) {
      case LoggerMode.DEBUG:
        this.log = console.log;
        this.error = console.error;
        break;

      case LoggerMode.ERROR:
        this.log = this.no_log;
        this.error = console.error;
        break;

      default:
        this.log = this.no_log;
        this.error = this.no_error;
        break;
    }

    //
    // never filter out errors in development  environment
    //
    if (isDevelopmentEnvironment()) {
      this.error = console.error;
    }
  }

  constructor(name?: string) {
    if (name) {
      this.className = name;
    } else {
      var err = getErrorObject();
      var caller_line = err.stack.split("\n")[3];
      const browser = this.getBrowser();
      if (browser.includes("Safari") || browser.includes("Firefox")) {
        caller_line = err.stack.split("\n")[2];
      }
      var clean = "";
      if (caller_line) {
        var index1 = caller_line.indexOf("at ");
        var index2 = caller_line.indexOf("(");
        clean = caller_line.slice(index1 + 2, index2).trim();

        var index3 = clean.indexOf("src/");
        clean = clean.slice(index3 + 4, clean.length);
        clean = clean.split("@")[0];
      }
      this.className = clean || "?";
    }

    let xmode = this.mode;
    // this.log = console.log;
    // this.error = console.error;

    this.applyMode();
    this.checkParentAvailable();
    Logger.allLoggers.push(this);
  }

  devError(message?: any, ...optionalParams: any[]) {
    if (isDevelopmentEnvironment()) {
      // only in developer mode
      this.x_error(message, ...optionalParams);
    }
  }

  error(message?: any, ...optionalParams: any[]) {
    this.x_error(message, ...optionalParams);
  }

  x_error(message?: any, ...optionalParams: any[]) {
    if (this.mode == "D" || this.mode == "E") {
      console.error(`${this.className}: ${message}`, ...optionalParams);
    }
  }

  no_error(message?: any, ...optionalParams: any[]) {}

  no_log(text: string, ...rest: any[]) {}

  log(text: string, ...rest: any[]) {
    if (process.env.NODE_ENV === "development") {
      //    if (isDevelopmentEnvironment()) {
      this.x_log(text, ...rest);
    }
  }

  x_log(text: string, ...rest: any[]) {
    var err = getErrorObject();
    var caller_line = err.stack.split("\n")[3];
    var clean = "";
    if (caller_line) {
      var index1 = caller_line.indexOf("at ");
      var index2 = caller_line.indexOf("(");
      clean = caller_line.slice(index1 + 2, index2).trim();
    }
    console.log(clean + ": " + text, ...rest);

    // if (this.mode == "D") {
    //   if (this.className) {
    //     console.log(`${this.className}: ${text}`, ...rest);
    //   }
  }

  private checkParentAvailable() {
    // check if all is already in it
    if (!Logger.allLoggerParents.has("All")) {
      // no itx
      Logger.allLoggerParents.set("All", "D"); // no itx
    }

    const loggerStructure = this.className.split("/");
    for (let i = 0; i < loggerStructure.length; i++) {
      if (i != loggerStructure.length - 1) {
        /// check if logger "parent" is already available

        let loggerName = loggerStructure[0];
        for (let j = 1; j <= i; j++) {
          loggerName = loggerName + "/" + loggerStructure[j];
        }
        if (!Logger.allLoggerParents.has(loggerName)) {
          Logger.allLoggerParents.set(loggerName, "D");
        }
      }
    }
  }
  private getBrowser() {
    let browser = "Unknown";
    let id = "";
    const userAgent = window.navigator.userAgent;
    try {
      if (userAgent.indexOf("Firefox") !== -1) {
        browser = "Mozilla Firefox";
        id = "Firefox";
      } else if (userAgent.indexOf("Edg") !== -1) {
        browser = "Microsoft Edge";
        id = "Edg";
      } else if (userAgent.indexOf("OPR") !== -1) {
        browser = "Opera";
        id = "OPR";
      } else if (userAgent.indexOf("MSIE") !== -1) {
        browser = "Internet Explorer";
        id = "MSIE";
      } else if (userAgent.indexOf("Trident/") !== -1) {
        browser = "Internet Explorer";
        id = "Trident/";
      } else if (userAgent.indexOf("Chrome") !== -1) {
        browser = "Google Chrome";
        id = "Chrome";
      } else if (userAgent.indexOf("Safari") !== -1) {
        browser = "Apple Safari";
        id = "Safari";
      }
      browser += userAgent.split(id)[1].split(" ")[0]; // version
    } catch (ex) {
      console.log(ex);
    }

    return browser;
  }
}
